import { exists } from '@/api'

export interface ReferenceImageMasterCreateRequest {
  title: string
  fileName: string
}

export function ReferenceImageMasterCreateRequestFromJSON(
  json: any
): ReferenceImageMasterCreateRequest {
  return ReferenceImageMasterCreateRequestFromJSONTyped(json)
}

export function ReferenceImageMasterCreateRequestFromJSONTyped(
  json: any
): ReferenceImageMasterCreateRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    title: exists(json, 'title') ? json.title : '',
    fileName: exists(json, 'file_name') ? json.file_name : ''
  }
}

export function ReferenceImageMasterCreateRequestToJSON(
  value: ReferenceImageMasterCreateRequest
): any {
  return {
    title: value.title,
    file_name: value.fileName
  }
}
